/**
 * filename: iconBoxes.js
 * Home page top samll icon boxex
 */

import React, { Component } from 'react';
import * as dataService from '../service/data-info-chart/requestsUtil';
import { COLORS, HEADER_INFO, WHITOUT_INFORMATION } from '../utils/constants';
import * as cbu from '../utils/checkBusinessUnit';
import * as formatter from '../utils/formatters';
import SimpleMonthPicker from './ui-components/SimpleMonthPicker';

export const BoxSingle = (props) => {
  // Used a style const for changing icon box
  // color using props.
  const style = {
    backgroundColor: props.iconbg
  };

  return (
    <div className="iconbox-single" style={{ height: '90%' }}>
      <div className="box-title">
        <div>
          <h5 style={{ color: COLORS.SUMMARY_GREEN }}>{props.title}</h5>
          <p style={{ color: COLORS.SUMMARY_GRAY }}>{props.subtitle}</p>
        </div>
      </div>
      <div className="chart">
        {props.children}
      </div>
    </div>
  );
};

class IconBoxes extends Component {

  constructor(props) {
    super(props);
    let date = new Date();
    this.state = {
      monthTarget: 0,
      baseIncome: 0,
      accumulatedIncome: 0,
      date: date,
      dateBox: WHITOUT_INFORMATION,
      goalAdvance: WHITOUT_INFORMATION,
      minIncome: 0,
      excess: 0,
      todayBill:0,
      remainingDays:0,
      averageIncome:0,
      estimatedIncome:0,
      estimatedBill:0
    };
  }

  componentDidMount() {
    this.fetch(this.state.date);
  }

  fetch(date) {
    let params = {
      id: cbu.checkBusinessUnit(this.props.bu),
      date: date
    };

    dataService.postFetch(HEADER_INFO, params)
      .then((json) => {
        let date;
        let goalAdvance;
        if(json.date===undefined||json.date===null){
          date=WHITOUT_INFORMATION;
        }
        else{
          date=json.date;
        }
        if(json.date===undefined||json.date===null){
          goalAdvance=WHITOUT_INFORMATION;
        }
        else{
          goalAdvance=json.goalAdvance.toString()+'%';
        }
        this.setState({
          monthTarget: formatter.formatNumberMoney(json.target),
          baseIncome: formatter.formatNumberMoney(json.base),
          accumulatedIncome: formatter.formatNumberMoney(json.amount),
          dateBox: date,
          goalAdvance: goalAdvance,
          excess: formatter.formatNumberMoney(json.excess),
          todayBill:formatter.formatNumberMoney(json.todayBill),
          remainingDays:json.remainingDays.toString(),
          averageIncome:formatter.formatNumberMoney(json.averageIncome),
          estimatedIncome:formatter.formatNumberMoney(json.estimatedIncomen),
          estimatedBill:formatter.formatNumberMoney(json.estimatedBill)
        });
      });
  }

  callback = (dataFromChild) => {
    this.props.callbackFromParent(dataFromChild);
    this.fetch(dataFromChild);
    this.setState({ date: dataFromChild });
  };

  render() {
    return (
      <div className="iconbox-wrapper">
        <div className="row">
          <div className="col-md-3">
            <BoxSingle
              title={this.state.monthTarget}
              subtitle="Meta del mes"
            >
            </BoxSingle>
          </div>

          <div className="col-md-3">
            <BoxSingle
              title={this.state.baseIncome}
              subtitle="Ingreso base"
            >
            </BoxSingle>
          </div>

          <div className="col-md-3">
            <BoxSingle
              title={this.state.accumulatedIncome}
              subtitle="Ingreso acumulado"
            >
            </BoxSingle>
          </div>
          <div className="col-md-3">
            <BoxSingle
              title={<SimpleMonthPicker callbackFromParent={this.callback}/>}
              subtitle="Periodo"
            >
            </BoxSingle>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <BoxSingle
              title={this.state.dateBox}
              subtitle="Ingreso acumulado al"
            >
            </BoxSingle>
          </div>

          <div className="col-md-3">
            <BoxSingle
              title={this.state.goalAdvance}
              subtitle="Avance vs meta"
            >
            </BoxSingle>
          </div>

          <div className="col-md-3">
            <BoxSingle
              title={this.state.excess}
              subtitle="Excedente"
            >
            </BoxSingle>
          </div>
          <div className="col-md-3">
            <BoxSingle
              title={this.state.todayBill}
              subtitle="Facturación al día de hoy"
            >
            </BoxSingle>
          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <BoxSingle
              title={this.state.remainingDays}
              subtitle="Días restantes del mes"
            >
            </BoxSingle>
          </div>

          <div className="col-md-3">
            <BoxSingle
              title={this.state.averageIncome}
              subtitle="Ingreso promedio / día hábil"
            >
            </BoxSingle>
          </div>

          <div className="col-md-3">
            <BoxSingle
              title={this.state.estimatedIncome}
              subtitle="Ingreso estimado al cierre"
            >
            </BoxSingle>
          </div>
          <div className="col-md-3">
            <BoxSingle
              title={this.state.estimatedBill}
              subtitle="Facturación final estimada"
            >
            </BoxSingle>
          </div>
        </div>
      </div>
    );
  }

}

export default IconBoxes;



// WEBPACK FOOTER //
// ./src/components/iconBoxes.js